import { Container, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { PageContainer, Tile, TileContent } from 'components/Layout/PageContainer';
import { UserTokensTable } from './UserTokensTable';

export function UserTokensView() {
  const location = useLocation();
  const userId = (location.state as { userId?: string })?.userId;
  const userName = (location.state as { userName?: string })?.userName;

  if (!userId) {
    return (
      <Container className="px-10">
        <PageContainer>
          <Tile>
            <TileContent>
              <div className="flex flex-row items-center justify-center py-8">
                <Typography variant="body1" sx={{ fontWeight: 700 }}>
                  <FormattedMessage id="api_access.user_tokens.user_not_found" />
                </Typography>
              </div>
            </TileContent>
          </Tile>
        </PageContainer>
      </Container>
    );
  }

  return <UserTokensTable userId={userId} userName={userName} />;
}
